import {IApplicationAnswer, TrackingStatus} from '../application/ApplicationModel'
import {ITagModel} from '../tag/TagModel'
import {StepOutcome} from '../process-flow/HrProcessStepModel'

export const HR_TRACKING_PATH = '/hr/tracking'

export type StepType = 'STEP' | 'END'

export interface IStepOption {
  id: string
  name: string
  stepType: StepType
}

export interface ITrackingHistory {
  action: 'START' | 'ADVANCE' | 'BACK' | 'STATUS'
  fromStepName?: string | null
  toStepName?: string | null
  status?: TrackingStatus | null
  createdDate?: string
}

/** CandidateTrackingDto */
export interface ITrackingModel {
  id: string
  applyJobId: string
  candidateId?: string | null
  tags?: ITagModel[]
  firstname: string
  lastname: string
  email: string
  phone?: string | null
  documentId?: string | null
  jobId: string
  jobTitle: string
  hrProcessId: string
  hrProcessName: string
  currentStepId?: string | null
  currentStepName?: string | null
  currentStepType?: StepType | null
  /** Adım süreç akışından silinmişse ilerle/geri yapılamaz */
  currentStepMissing: boolean
  /** Birden fazlaysa (dallanma) kullanıcı seçer */
  nextSteps: IStepOption[]
  previousStep?: IStepOption | null
  status: TrackingStatus
  /** Tamamlanan süreçte ulaşılan Bitiş adımının sonucu */
  outcome?: StepOutcome | null
  /** Arama havuzundan başlatıldıysa adayı arayan kullanıcı; takip yalnızca ona görünür */
  assignedUserName?: string | null
  salaryExpectation?: string | null
  note?: string | null
  createdDate?: string
  updatedDate?: string
  history?: ITrackingHistory[]
  answers?: IApplicationAnswer[]
}

export interface ITrackingUpdateRequest {
  status: TrackingStatus
  note: string
}

export const HISTORY_ACTION_LABEL: Record<ITrackingHistory['action'], string> = {
  START: 'Süreç başlatıldı',
  ADVANCE: 'İlerletildi',
  BACK: 'Geri alındı',
  STATUS: 'Durum değiştirildi',
}

export const canAdvance = (tracking: ITrackingModel) =>
  tracking.status !== 'CANCELLED' && !tracking.currentStepMissing && tracking.nextSteps.length > 0

export const canGoBack = (tracking: ITrackingModel) =>
  tracking.status !== 'CANCELLED' && !tracking.currentStepMissing && !!tracking.previousStep
